<button class="sidebar-toggle" (click)="isOpen = !isOpen" aria-label="Toggle navigation">
  <i class="zmdi zmdi-menu"></i>
</button>

<div class="sidebar-backdrop" [class.is-visible]="isOpen" (click)="isOpen = false"></div>

<nav id="sidebar" [class.is-open]="isOpen">
  <button class="sidebar-close" (click)="isOpen = false" aria-label="Close navigation">
    <i class="zmdi zmdi-close"></i>
  </button>
  <ul class="list-unstyled components">
    <li routerLinkActive="active">
      <a routerLink="model" (click)="isOpen = false"><i class="zmdi zmdi-globe"></i><span class="hidden-xs">Model</span></a>
    </li>

    <li routerLinkActive="active">
      <a routerLink="job" (click)="isOpen = false"><i class="zmdi zmdi-grid"></i><span class="hidden-xs">Job</span></a>
    </li>
    <li routerLinkActive="active">
      <a routerLink="costs" (click)="isOpen = false"><i class="zmdi zmdi-border-clear"></i><span class="hidden-xs">Grid</span></a>
    </li>
    <li routerLinkActive="active">
      <a routerLink="charts" (click)="isOpen = false"><i class="zmdi zmdi-chart"></i><span class="hidden-xs">Charts</span></a>
    </li>
    <li routerLinkActive="active">
      <a routerLink="shots" (click)="isOpen = false"><i class="zmdi zmdi-image"></i><span class="hidden-xs">Shots</span></a>
    </li>
    @if (runfileAccess) {
    <li routerLinkActive="active">
      <a routerLink="runfile" (click)="isOpen = false"><i class="zmdi zmdi-file"></i><span class="hidden-xs">Runfile</span></a>
    </li>
    }
    <li routerLinkActive="active">
      <a routerLink="files" (click)="isOpen = false"><i class="zmdi zmdi-folder-outline"></i><span class="hidden-xs">Files</span></a>
    </li>
    <li routerLinkActive="active">
      <a routerLink="tables" (click)="isOpen = false"><i class="zmdi zmdi-format-list-bulleted"></i>
        <span class="hidden-xs">Tables</span></a>
    </li>
    <li routerLinkActive="active">
      <a routerLink="env_vars" (click)="isOpen = false"><i class="zmdi zmdi-settings"></i>
        <span class="hidden-xs">Env Vars</span></a>
    </li>
  </ul>
</nav>
